module.exports = __webpack_public_path__ + "img/mastercard.40dbf2e0.png";